/* eslint-disable react/jsx-boolean-value */
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import React from 'react'
import { DateRange } from 'react-date-range'
import './index.scss'

const DateRangePicker = ({ value, setValue }) => {
  return (
    <DateRange
      className='calendarRangeBox'
      editableDateInputs={true}
      onChange={item => setValue([item.selection])}
      moveRangeOnFirstSelection={false}
      ranges={value}
    />
  )
}

export default DateRangePicker
